module.exports = __webpack_public_path__ + "static/media/8.95309933.jpg";